//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AssignWeldPMI",1,0],[0,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[1,"ContourHeight",0,"Expression",0],[0,"ContourType",1,0],[0,"CreateSkipWelds",1,0],[0,"DistanceTolerance",1,0],[1,"EdgeSet1",0,"Section",0],[1,"EdgeSet2",0,"Section",0],[0,"EdgeType",1,0],[1,"EndAngle",0,"Expression",0],[1,"EndDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"FaceSet1",0,"ScCollector",0],[1,"FaceSet2",0,"ScCollector",0],[1,"GrooveAngle",0,"Expression",0],[1,"GrooveRadius",0,"Expression",0],[0,"IsRootOpening",1,0],[0,"IsRootPenetration",1,0],[0,"Method",1,0],[1,"NumberOfWelds",0,"Expression",0],[1,"PenetrationDepth",0,"Expression",0],[0,"PrepareEdges",1,0],[0,"RecreateDeletedWelds",1,0],[0,"RemoveHoles",1,0],[1,"RootOpening",0,"Expression",0],[1,"RootPenetration",0,"Expression",0],[1,"SecondPenetrationDepth",0,"Expression",0],[0,"SeedFace1",1,"Face",0],[0,"SeedFace2",1,"Face",0],[0,"SeedPoint1",1,0],[0,"SeedPoint2",1,0],[1,"SegmentLength",0,"Expression",0],[0,"SingleFaceSet",1,0],[1,"Spacing",0,"Expression",0],[1,"StartAngle",0,"Expression",0],[1,"StartDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"TaperMethod",1,0],[0,"Type",1,0],[0,"Uparameter1",1,0],[0,"Uparameter2",1,0],[0,"UseFillin",1,0],[0,"Vparameter1",1,0],[0,"Vparameter2",1,0],[0,"WeldSymmetric",1,0]],[],[]];
SPLM.Weld.WeldGrooveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldGrooveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldGrooveBuilder.Types = Object.freeze({
    "SquareButt" : "SquareButt", "VGroove" : "VGroove", "BevelGroove" : "BevelGroove", "UGroove" : "UGroove", "JGroove" : "JGroove", "FlaredVGroove" : "FlaredVGroove", "FlaredBevelGroove" : "FlaredBevelGroove", "FillinFlaredVGroove" : "FillinFlaredVGroove", "FillinFlaredBevelGroove" : "FillinFlaredBevelGroove"});

SPLM.Weld.WeldGrooveBuilder.Contour = Object.freeze({
    "None" : "None", "Convex" : "Convex", "Flush" : "Flush", "Concave" : "Concave"});

SPLM.Weld.WeldGrooveBuilder.SkipWeldMethod = Object.freeze({
    "NumberLength" : "NumberLength", "NumberSpacing" : "NumberSpacing", "SpacingLength" : "SpacingLength"});

SPLM.Weld.WeldGrooveBuilder.Edge = Object.freeze({
    "NotPrepared" : "NotPrepared", "Prepared" : "Prepared"});

SPLM.Weld.WeldGrooveBuilder.Prepare = Object.freeze({
    "None" : "None", "EntireLength" : "EntireLength", "WeldLimits" : "WeldLimits", "Complex" : "Complex"});

SPLM.Weld.WeldGrooveBuilder.Taper = Object.freeze({
    "FromEndFace" : "FromEndFace", "FromTopFace" : "FromTopFace"});

export default SPLM;